// extracted by mini-css-extract-plugin
export default {"gameName":"GameName__gameName--O3L"};